import {createSlice} from "@reduxjs/toolkit";

const initialManageBlocksState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  ManageBlocksForEdit: undefined,
  lastError: null,
  council:[]
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const ManageBlocksSlice = createSlice({
  name: "ManageBlocks",
  initialState: initialManageBlocksState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCustomerById
    customerFetched: (state, action) => {
      state.actionsLoading = false;
      state.ManageBlocksForEdit = action.payload.ManageBlocksForEdit;
      state.error = null;
    },
    // findTowns
    blocksFetched: (state, action) => {
      // const { totalCount, entities } = action.payload;
      const { length, data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = data;
      state.totalCount = length;
     
    },

     // getCouncil
     CouncilFetched: (state, action) => {
      const { data } = action.payload;
      state.council = data;
    
    },

       // getCouncil
      //  CouncilFetched: (state, action) => {
      //   const { data } = action.payload;
      //   state.council = data;
      
      // },

    // createCustomer
    customerCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.customer);
    },
    // updateCustomer
    TownUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.ManageTown.id) {
          return action.payload.ManageTown;
        }
        return entity;
      });
    },
    // deleteCustomer
    blockDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteCustomers
    customersDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // customersUpdateState
    customersStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
